import React, { useState } from "react";
import PaymentsLogo from "../../Assets/RegisterPage/PaymentsLogo.png";
import Lottie from "react-lottie";
import CheckMarkLottie from "../../Assets/ClientPortalLoginPage/CheckMarkLottie.json";
import { useUserStore } from "../../Store/User";
import { useParams } from "react-router-dom";
import MessageBanner from "../../Components/Molecules/PaymentsAppHeader/MessageBanner";

const AcceptUserInvitePage: React.FC = () => {
  const { acceptInvite } = useUserStore();
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email") || "";
  const teamName = urlParams.get("teamName") || "a team";
  const { team_invite_id } = useParams();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleAcceptInvite = async () => {
    if (!team_invite_id) {
      alert("Invalid team invite ID");
      return;
    }
    await acceptInvite(team_invite_id, firstName, lastName, urlParams.get("token") || "");
    setIsSubmitted(true);
  };

  return (
    <div className="flex flex-col h-full bg-gray-50 min-h-screen">
      <MessageBanner />
      <header className="flex justify-center items-center mt-10">
        <img src={PaymentsLogo} alt="Zomentum Payments Logo" className="h-12" />
      </header>

      <div className="flex-1 flex items-start justify-center pt-16">
        <div className="max-w-md w-full bg-white p-6 border rounded shadow-lg mt-10">
          {isSubmitted ? (
            <div className="flex flex-col items-center space-y-4 bg-white">
              <Lottie
                options={{ animationData: CheckMarkLottie }}
                width="14rem"
                isClickToPauseDisabled
                style={{ cursor: "default" }}
              />
              <div className="text-lime-600 text-2xl font-semibold">Invite Accepted!</div>
              <div className="text-center">
                You have successfully accepted the invite to join {teamName} at Zomentum Payments.
                Please check your email for further details to join your account.
              </div>
            </div>
          ) : (
            <>
              <h2 className="text-xl font-bold text-center mb-4">Accept User Invite</h2>
              <p className="text-center text-gray-600 mb-6">
                {teamName} has invited you to join their Zomentum Payments account.
              </p>
              <form
                className="flex flex-col gap-4"
                onSubmit={e => {
                  e.preventDefault();
                  handleAcceptInvite();
                }}
              >
                <div className="flex flex-col">
                  <label htmlFor="firstName" className="mb-1 font-medium">
                    First Name
                  </label>
                  <input
                    id="firstName"
                    type="text"
                    className="p-2 border rounded"
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    placeholder="Enter your first name"
                    required
                  />
                </div>
                <div className="flex flex-col">
                  <label htmlFor="lastName" className="mb-1 font-medium">
                    Last Name
                  </label>
                  <input
                    id="lastName"
                    type="text"
                    className="p-2 border rounded"
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    placeholder="Enter your last name"
                    required
                  />
                </div>
                <div className="flex flex-col">
                  <label htmlFor="email" className="mb-1 font-medium">
                    Email
                  </label>
                  <div id="email" className="p-2 border rounded bg-gray-100">
                    {email}
                  </div>
                </div>
                <button
                  type="submit"
                  className="mt-4 p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Accept Invite
                </button>
              </form>
            </>
          )}
        </div>
      </div>

      <footer className="text-center py-4 bg-gray-100 text-gray-600 text-sm">
        Zomentum Payments is a service by{" "}
        <a
          href="https://www.zomentum.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:underline"
        >
          Zomentum
        </a>
        .
      </footer>
    </div>
  );
};

export default AcceptUserInvitePage;
